import React from 'react';
import CombinedEditableSection from '../../../../../../components/CombinedEditableSection.comp';
import { tUi } from '../../../../../../../../utils/dq_lc';
import {
  SlideTitle,
} from '../../../../../styles/LearnTab/slideBase.styles';
import {
  ActivityContainer,
  ActivityLeft,
  ActivityRight,
  FullActivityPill,
  ActivityContent,
  JournalingTextArea,
  SaveButton,
} from '../../../../../styles/LearnTab/activity.styles';
import { SlideTitleHeader } from '../common/SlideTitleHeader.comp';
import { renderTextWithId } from '../common/EditableSlideField.comp';

export const JournalingSlide = ({
  slide,
  highlightWord,
  isEditMode = false,
  slideEdits = {},
  showEnglishContent = false,
  onSaveEdit,
  onResetEdit,
  onCancelEdit,
  uiLocale = 'en-US',
}) => {
  const origin = slide?._pbdq_origin || slide || {};
  const journalTitle = slide?.SlideTitle || origin.journaling_title || origin.title || '';
  const journalPrompt = origin.prompt || origin.journaling_prompt || origin.reflective_question || slide?.SlideContent || '';

  const textRendererOptions = { slideEdits, showEnglishContent, highlightWord };

  return (
    <ActivityContainer style={{ maxWidth: '1500px', width: '100%' }}>
      <ActivityLeft>
        <FullActivityPill>{tUi('slide.activity.journalingTime', uiLocale)}</FullActivityPill>
        {isEditMode ? (
          <CombinedEditableSection
            slide={slide}
            isEditMode={isEditMode}
            slideEdits={slideEdits}
            showEnglishContent={showEnglishContent}
            onSave={onSaveEdit}
            onReset={onResetEdit}
            onCancel={onCancelEdit}
            TitleComponent={SlideTitle}
            ContentComponent={ActivityContent}
          />
        ) : (
          <>
            {journalTitle ? (
              <SlideTitle>
                {highlightWord ? highlightWord('title', journalTitle) : journalTitle}
              </SlideTitle>
            ) : (
              <SlideTitleHeader
                slide={slide}
                slideEdits={slideEdits}
                showEnglishContent={showEnglishContent}
                highlightWord={highlightWord}
              />
            )}
            {journalPrompt && renderTextWithId('content_0', journalPrompt, ActivityContent, {}, textRendererOptions)}
          </>
        )}
      </ActivityLeft>
      <ActivityRight>
        <JournalingTextArea
          placeholder={tUi('slide.activity.journalingPlaceholder', uiLocale)}
          multiline
          minRows={10}
        />
        <SaveButton>{tUi('slide.activity.save', uiLocale)}</SaveButton>
      </ActivityRight>
    </ActivityContainer>
  );
};

export default JournalingSlide;
